/**
 * 認証に関するユーティリティ関数
 */

import decodeAccessToken from "./decode_access_token";
import { getUserStorage } from "./local_storage";

export type JWTDecoded = {
  user_id: number;
  user_type: string;
  identification_cd: string;
  identification_name: string;
  user_name: string;
  store_name: string;
  iat: number;
  exp: number;
};

/**
 * アクセストークンを返却する
 * @returns アクセストークン
 */
export function getAccessTokenFromLocalStorage() {
  // アクセストークンを返却する
  const user = getUserStorage();
  const token = user?.accessToken;
  return token ?? ""; // perseがないと"で囲まれてしまう
}

/**
 * リフレッシュトークンを返却する
 * @returns リフレッシュトークン
 */
export function getRefreshTokenFromLocalStorage() {
  // リフレッシュトークンを返却する
  const user = getUserStorage();
  const token = user?.refreshToken;
  return token ?? "";
}

/**
 * アクセストークン期限切れかどうか。切れているならtrue
 */
export function checkAccessTokenExpired() {
  const accToken = getAccessTokenFromLocalStorage();
  const decoded = decodeAccessToken(accToken);
  if (decoded) {
    const { exp } = decoded as { exp: number };
    const now = Math.floor(Date.now() / 1000);
    // アクセストークンが期限切れか？
    return now > exp;
  }
  // デコードに失敗したら期限切れ
  return true;
}

/**
 * ユーザー種別を返却する
 * @returns ユーザー種別
 */
export function getUserType() {
  const accToken = getAccessTokenFromLocalStorage();
  const decoded = decodeAccessToken(accToken);
  if (decoded) {
    const { user_type: userType } = decoded as { user_type: string };
    return userType;
  }
  return null;
}

/**
 * ユーザー種別から在庫画面のパスを返す
 * @returns 在庫画面のパス
 */
export function getStockPathByUserType() {
  const userType = getUserType();
  let path = "";
  switch (userType) {
    case "C0001": // 商品部
    case "C0005": // 自社倉庫
      path = "/stock/main";
      break;
    // ToDo: 店舗・企業・得意先は後々リリースする。
    // case "C0002": // 店舗
    //   path = "/stock/store";
    //   break;
    case "C0004": // 仕入先
    case "C0007": // 伊藤忠
    case "C0008": // 昭和製氷
      path = "/stock/supplier";
      break;
    // ToDo: 店舗・企業・得意先は後々リリースする。
    // case "C0006": // 企業
    //   path = "/stock/company";
    //   break;
    case "C0003": // 得意先
      path = "/stock/company"; // あえて権限のないパスを挿入defaultがstock/clientのため。
      // path = "/stock/client";
      break;
    default:
      path = "/stock/client";
      break;
  }
  return path;
}

/**
 * ローカルストレージにログイン後パースしたデータを入れる
 * @param decoded デコードされたJWT
 */
export function setCodeInLocalStorage(decoded: JWTDecoded) {
  const userType = getUserType();
  const loginLocalStorage = {
    supplier_cd: "",
    warehouse_cd: "",
    shop_cd: "",
    company_cd: "",
  };
  switch (userType) {
    case "C0001":
    case "C0005":
      break;
    case "C0002":
      loginLocalStorage.shop_cd = decoded.identification_cd;
      break;
    case "C0004":
      loginLocalStorage.supplier_cd = decoded.identification_cd;
      break;
    case "C0007":
      loginLocalStorage.warehouse_cd = "soko01";
      break;
    case "C0008":
      loginLocalStorage.warehouse_cd = "soko02";
      break;
    case "C0006":
      loginLocalStorage.company_cd = decoded.identification_cd;
      loginLocalStorage.shop_cd = decoded.identification_cd;
      break;
    case "C0003":
    default:
      break;
  }

  // ユーザータイプを入れる
  if (userType) localStorage.setItem("user_type", userType);

  // 使うもののみ代入し、それ以外は削除
  Object.keys(loginLocalStorage).forEach((key: string) => {
    if (loginLocalStorage[key as keyof typeof loginLocalStorage]) {
      localStorage.setItem(key, `${loginLocalStorage[key as keyof typeof loginLocalStorage]}`);
    } else {
      localStorage.removeItem(key);
    }
  });
}
